import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import MobileHeader from "../../../layout/DriverLayout/Header";
import BannerBox from "./Components/Banner";
import ClubTabbar from "./Components/ClubTabbar";
import TabContents from "./Components/TabContents";

export default function KarenClubPage() {
  const [activeTab, setActiveTab] = useState(0);

  //   useEffect(() => {
  //     console.log(activeTab);
  //   }, [activeTab]);

  return (
    <>
      <Box
        sx={{
          // border: "1px solid gray",
          position: "sticky",
          zIndex: 50,
          boxShadow: "0px 0px 16px 0px rgba(0,0,0,0.2)",
        }}
      >
        <MobileHeader
          title={
            <Typography
              sx={{
                fontWeight: 600,
                color: "secondary.main",
                fontSize: 16,
              }}
            >
              کارن کلاب{" "}
            </Typography>
          }
          hasScroll={false}
        />
        <Box
          sx={{
            paddingX: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <BannerBox />
          <ClubTabbar
            tab={activeTab}
            getActiveTab={(tab) => setActiveTab(tab)}
          />
        </Box>
      </Box>
      <Box
        sx={{
          // border: "1px solid gray",
          flex: 1,
          overflowY: "hidden",
        }}
      >
        <TabContents
          getActiveTab={(tab) => setActiveTab(tab)}
          tab={activeTab}
        />
      </Box>
      <BottomTabbar />
    </>
  );
}
